import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LigeriaWordmark } from "@/components/Logo";

const NAV = [
  { label: "Accueil", to: "/", hash: null },
  { label: "Catalogue Tremblay", to: "/catalogue", hash: null },
  { label: "PANTHER", to: "/", hash: "panther" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToHash = (hash) => {
    const el = document.getElementById(hash);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const go = (to, hash) => {
    setOpen(false);
    if (location.pathname !== to) {
      navigate(to);
      if (hash) setTimeout(() => scrollToHash(hash), 350);
    } else if (hash) {
      scrollToHash(hash);
    } else if (to === "/catalogue") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link" className="shrink-0" onClick={() => setOpen(false)}>
          <LigeriaWordmark />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) =>
            n.hash === "panther" ? (
              <button
                key={n.label}
                data-testid="nav-band-panther"
                onClick={() => go(n.to, n.hash)}
                aria-label="PANTHER — Design for you"
                title="PANTHER — Design for you"
                className="h-10 w-auto shrink-0 transition-transform duration-200 hover:scale-105"
              >
                <img src="/img/panther-band.png" alt="PANTHER" className="h-full w-auto" />
              </button>
            ) : n.label === "Catalogue Tremblay" ? (
              <button
                key={n.label}
                data-testid="nav-logo-tremblay"
                onClick={() => go(n.to, n.hash)}
                aria-label="Catalogue Tremblay"
                title="Catalogue Tremblay"
                className="h-9 w-auto shrink-0 transition-transform duration-200 hover:scale-105"
              >
                <img src="/img/logo-tremblay.png" alt="Catalogue Tremblay" className="h-full w-auto rounded-md" />
              </button>
            ) : (
              <button
                key={n.label}
                data-testid={`nav-link-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => go(n.to, n.hash)}
                className="font-accent uppercase tracking-[0.22em] text-sm text-white/70 hover:text-white transition-colors duration-200"
              >
                {n.label}
              </button>
            )
          )}
          <button
            data-testid="nav-cta-quote"
            onClick={() => go("/catalogue", "demande")}
            className="font-accent uppercase tracking-[0.22em] text-sm px-6 py-2.5 bg-blaze text-white hover:-translate-y-0.5 hover:shadow-[0_10px_30px_rgba(200,16,46,0.35)] transition-all duration-200"
          >
            Demander un devis
          </button>
        </nav>

        <button
          className="md:hidden text-white p-2"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {NAV.map((n) => (
            <button
              key={n.label}
              data-testid={`nav-mobile-link-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => go(n.to, n.hash)}
              className="text-left font-accent uppercase tracking-[0.22em] text-base text-white/80"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-cta-quote"
            onClick={() => go("/catalogue", "demande")}
            className="text-left font-accent uppercase tracking-[0.22em] text-base px-6 py-3 bg-blaze text-white w-fit"
          >
            Demander un devis
          </button>
        </div>
      )}
    </header>
  );
};
